import { ReactNode } from "react";

import { Classes } from "@blueprintjs/core";
import styled from "@emotion/styled";

import { StyledDialog } from "@/components/pieces/StyledDialog";
import { cn } from "@/lib/utils";

const ShareStyledDialog = styled(StyledDialog)`
  .${Classes.DIALOG_HEADER} {
    padding-left: 16px !important;
    padding-right: 8px !important;
  }
`;

interface ShareDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title?: string | ReactNode;
  className?: string;
  children: ReactNode;
}

export function ShareDialog({
  open,
  onOpenChange,
  title = "Share",
  className,
  children,
}: ShareDialogProps) {
  return (
    <ShareStyledDialog
      isOpen={open}
      onClose={() => onOpenChange(false)}
      lazy={true}
      title={
        typeof title === "string" ? (
          <div className="text-lg">{title}</div>
        ) : (
          title
        )
      }
      width="550px"
      className={cn(className)}
    >
      <div className="p-4 space-y-4">{children}</div>
    </ShareStyledDialog>
  );
}
